module.exports = __webpack_public_path__ + "static/media/PricingDQWorkspace3.a9a9269f.png";